import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import {
  CommonMediaQueries,
  DropdownModule,
  IconModule,
  MediaScreenService,
} from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent } from '@iw/common';
import { IwDialogService } from '@iw/core/services';

import { CurrencyRateContentComponent } from './currency-rate-content/currency-rate-content.component';

@Component({
  imports: [
    ButtonComponent,
    DropdownModule,
    TranslateModule,
    IconModule,
    AsyncPipe,
    CurrencyRateContentComponent,
  ],
  selector: 'iw-currency-rate',
  templateUrl: './currency-rate.component.html',
  styleUrls: ['./currency-rate.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencyRateComponent {
  readonly #mediaScreenService = inject(MediaScreenService);
  readonly #dialogService = inject(IwDialogService);

  isDesktop = toSignal(
    this.#mediaScreenService.mediaMatcher(CommonMediaQueries.MD),
  );

  openDialog(): void {
    this.#dialogService.open({
      components: [CurrencyRateContentComponent],
    });
  }
}
